export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14407.e6ea74a1.jpg";